import { render, staticRenderFns } from "./Bbq-master.vue?vue&type=template&id=f7140fd6&scoped=true&"
import script from "./Bbq-master.vue?vue&type=script&lang=js&"
export * from "./Bbq-master.vue?vue&type=script&lang=js&"
import style0 from "./Bbq-master.vue?vue&type=style&index=0&id=f7140fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7140fd6",
  null
  
)

export default component.exports